/** PURE_IMPORTS_START  PURE_IMPORTS_END */
"use strict";
/*@__PURE__*/ Object.defineProperty(exports, "__esModule", { value: true });
function identity(x) {
    return x;
}
exports.identity = identity;
